import { createSlice } from '@reduxjs/toolkit' //next js redux toolkit  
import actualMovements from "../../common-utilities/utils/sampleMovments.json";
import actualPartialTrips from "../../common-utilities/utils/partialTrip.json";

export const globalDataSlice = createSlice({
  name: 'globalData',
  initialState: {
    movements: [...actualMovements],
    trips: [...actualPartialTrips]
  },
  reducers: {
    setMovementsReducer: (state, action) => {
      state.movements = action.payload.movements
      return state;
    },
    setTripsReducer: (state, action) => {
      state.trips = action.payload.trips
      return state;
    }
  }
})
// case under reducers becomes an action 
export const { setMovementsReducer, setTripsReducer } = globalDataSlice.actions
export default globalDataSlice.reducer 
